import request from "../../Request";
import {rThen} from "../../requestThen";

export let getPedagogList = async (kindegartenId, offset, count) => {

    return request.get(`/api/gartens/get_pedagogs/list/${kindegartenId}/${offset}/${count}`, true).then(r => {
        return rThen(r);
    })
}